import type { DmpChatTurn } from './state/dmpChatState'

export const DMP_CHAT_APPLICATION_KEY = 'project' as const
export const DMP_CHAT_AGENT_KEY = 'project' as const
export const DMP_CHAT_TASK_NAME = 7 as const
export const DMP_CHAT_SCHEMA_VERSION = '1' as const
export const DMP_CHAT_CLIENT_TYPE = 'frontend' as const
export const DMP_CHAT_CORRELATION_ID_HEADER = 'X-Correlation-ID' as const

export interface DmpChatTaskBody {
  projectId: number
  organisationId: number
  applicationKey: typeof DMP_CHAT_APPLICATION_KEY
  taskName: typeof DMP_CHAT_TASK_NAME
  payload: {
    Message: string
    AppKey: typeof DMP_CHAT_APPLICATION_KEY
    AgentKey: string
    ChatId: string
    ChatHistoryId: string
    Attachments?: readonly {
      InputRef: string
      Filename: string
    }[]
  }
  schemaVersion: typeof DMP_CHAT_SCHEMA_VERSION
}

export function createDmpChatTaskBody(
  projectId: number,
  organisationId: number,
  turn: DmpChatTurn,
  agentKey: string = DMP_CHAT_AGENT_KEY
): DmpChatTaskBody {
  return {
    projectId,
    organisationId,
    applicationKey: DMP_CHAT_APPLICATION_KEY,
    taskName: DMP_CHAT_TASK_NAME,
    payload: {
      Message: turn.prompt,
      AppKey: DMP_CHAT_APPLICATION_KEY,
      AgentKey: agentKey,
      ChatId: turn.chatId,
      ChatHistoryId: turn.chatHistoryId,
      ...(turn.attachments.length > 0
        ? {
            Attachments: turn.attachments.map((attachment) => ({
              InputRef: attachment.inputRef,
              Filename: attachment.filename,
            })),
          }
        : {}),
    },
    schemaVersion: DMP_CHAT_SCHEMA_VERSION,
  }
}

export function createDmpChatCancellationMessage(requestId: string): string {
  return JSON.stringify({
    type: 'cancel',
    requestId,
  })
}
